module.exports = __webpack_public_path__ + "img/emoji-huh-240x240.bb91436a.png";